<template lang="pug">
.box-content-classes-me
  .box-exercise-content
    .row(v-if="lstExercises && lstExercises.length")
      div(v-for="(exercise, index) in lstExercises")
        FrontItem.col-md-6.col-sm-6.col-xs-12(:exercise="exercise" :key="count" :url="getLinkMore()" :obj_id="exercise.id" ref="frontItem")
      .clearfix
    .row(v-else)
      .no-data.col-md-12.col-sm-12.col-xs-12 {{no_data}}
  .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphql'
import graphqlfront from '../../Model/graphqlfront'
import FrontItem from './Item.vue'
// import moment from 'moment'
export default {
  components: {
    FrontItem
  },
  props: {
    teacherID: String,
    pcID: Number,
    classID: Number,
    pcInfo: Object
  },
  data() {
    return {
      count: 0,
      lstExercises: [],
      loader: null,
      currentPage: 1,
      isLoadMore: false,
      limit: 6,
      classesInfo: [],
      gradeID: 0,
      no_data: this.$t('home.no_data')
    }
  },
  methods: {
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    increment() {
      this.count++
    },
    getLinkMore() {
      return 'landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id
    },
    async getInfoClasses() {
      if (this.classID > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphqlfront.GET_CLASSES),
          variables: {
            where: {id: {_eq: this.classID}}
          }
        }).catch((error) => {
          this.error = error.message
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          console.error(error)
        })
        if (data.classes && data.classes.length > 0) {
          this.classesInfo = data.classes
          this.gradeID = data.classes[0].grade_id
          this.autoRefresh()
        }
      }
    },
    async autoRefresh() {
      this.show()
      var date = new Date().toISOString()
      var objWhere = {
        grade_id: {_eq: Number(this.gradeID)},
        class_id: {_eq: this.classID},
        start_date: {_lte: date}
      }
      var variables = {
        where: objWhere,
        order_by: {updated_at: 'desc', name: 'asc'},
        limit: this.limit,
        offset: (this.currentPage - 1) * this.limit
      }
      await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_ME_EXERCISE),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        this.lstExercises = response.data.v_front_exercise_class_me
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
      this.$delete(variables, 'offset')
      this.$delete(variables, 'limit')
      await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_ME_EXERCISE),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        this.lstCounts = response.data.v_front_exercise_class_me.length
        this.loader.hide()
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
        this.loader.hide()
      })
      this.increment()
    },
    handleScrollExercise() {
      let scrollTop = this.getScrollTop(window)
      let element = document.getElementById('containerId')
      if (element !== undefined && element !== null) {
        let clientHeight = element.clientHeight
        let windowHeight = window.innerHeight
        let pageCount = Math.ceil(this.lstCounts / this.limit)
        if (this.currentPage < pageCount && !this.isLoadMore && scrollTop + windowHeight > clientHeight) {
          this.isLoadMore = true
          this.currentPage++
          setTimeout(() => {
            this.autoRefresh()
          }, 200)
        }
      }
    },
    getScrollTop(element) {
      if (element === window) return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
      return element.scrollTop
    }
  },
  async mounted () {
    window.addEventListener('scroll', this.handleScrollExercise)
    await this.getInfoClasses()
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.box-content-classes-me{
  .box-exercise-content{
    .box-parent-exercise{margin-bottom:30px;
      .box-item-exercise{cursor: pointer; border-radius: 10px; position: relative; height: 130px; overflow: hidden; box-shadow: 0px 1px 3px #00000029; 
        .overlay{width: 100%; position: absolute;height:100%; background: transparent linear-gradient(180deg, #FFED98 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box; top:0;}
        a{display: inline-block;
          &.grade-format{position: relative; background: #000000 0% 0% no-repeat padding-box; border-radius: 5px; color: #FFFFFF; font-size: 12px; margin: 8px 15px; padding: 4px 8px; z-index: 995; opacity: 0.5;}
        }
        .item-title{ position: relative; padding: 0 15px;width: 100%;
          span{color: #333333; font-weight: 400;}
        }
      }
      .item-social{margin-top:10px; display: table; width:100%;
          span { display: table-cell;  width: 33.33%;font-size:13px;
            i{color:#4B2D15; font-size:13px;
                &:before{padding-right: 5px;}
                img{width: 16px; height: 16px; margin-right: 5px; position: relative; top:-2px;}
            }
            i.like{cursor: pointer;}
          }
      }
    }
    .no-data{text-align: center; margin: 15px 0;color: #9F6A28; font-size:15px;}
  }
}
@media (max-width: 1366px){
 
}
@media (max-width: 1024px){
 
}
@media (max-width: 991px){
  .box-body-classes-me{
    .box-parent-exercise{width: 50%;}
  }       
}
@media (max-width: 768px){
  .box-body-classes-me{
    .box-parent-exercise{width: 50%;}
  } 
}
@media (max-width: 560px){
  .box-body-classes-me{
    .box-parent-exercise{width: 100%;}
  } 
}
@media (max-width: 375px){
  
}
</style>




// WEBPACK FOOTER //
// index.vue?cf912516